import { useState, useEffect } from 'react';
import { YearlyWealthDashboard } from 'accounts/components/yearly-wealth-dashboard/yearly-wealth-dashboard';
import { Tag } from 'components/HomeTag/HomeTag';
import Tabs from 'components/TabBar/TabBar';
import AccountPropertyBannerCard from 'containercomponents/AccountPropertyBannerCard/AccountPropertyBannerCard';
import AccountUnitDetailContainer from 'containers/AccountUnitDetailContainer/AccountUnitDetailContainer';
import { sortBy } from 'es-toolkit/compat';
import HomeownerAccountProperty from 'models/homeownerAccounts/HomeownerAccountProperty';
import HomeownerAccountUnit from 'models/homeownerAccounts/HomeownerAccountUnit';
import { HOME_STATUSES } from './home-status';

const TabBar = Tabs as any;

type HomeInfoProps = {
  accountProperty: HomeownerAccountProperty;
  units: HomeownerAccountUnit[];
};

export function HomeInfo({ accountProperty, units }: HomeInfoProps) {
  // The state really does start (and can go back to) empty — the effect only
  // fills it once there are units, and the tab handler sets whatever `find`
  // returns — so `null` and `undefined` belong in its type.
  const [unit, setUnit] = useState<HomeownerAccountUnit | null | undefined>(
    null,
  );

  useEffect(() => {
    if (units?.length) {
      setUnit(units[0]);
    }
  }, [units]);

  if (!unit || !accountProperty) {
    return null;
  }

  const homeStatus = HOME_STATUSES[unit.basicInfo.currentMilestone];

  return (
    <>
      <YearlyWealthDashboard
        homeId={unit.basicInfo.unitId}
        unitNumber={units.length > 1 ? unit.basicInfo.unitNumber : undefined}
      />
      <div className="relative mt-sm">
        {homeStatus && (
          <Tag
            className={`left-sm top-sm rounded-small ${homeStatus.colorClassName}`}
          >
            {homeStatus.label}
          </Tag>
        )}
        <AccountPropertyBannerCard
          coordinates={accountProperty.address.coordinates}
          imageUrl={units[0]?.basicInfo.bannerImageUrl}
          staticMapImageUrl={accountProperty.staticMapImageUrl}
        />
      </div>

      {units.length > 1 && (
        <div className="mt-md flex">
          <TabBar
            items={sortBy(
              units.map((unitItem) => ({
                text: `Unit ${unitItem.basicInfo.unitNumber}`,
                key: unitItem.basicInfo.unitId,
              })),
              (item: { text: string; key: string }) =>
                parseInt(item.text, 10) || item.text,
            )}
            onSelect={(item: { text: string; key: string }) => {
              const selectedUnit = units.find(
                (unitItem) => unitItem.basicInfo.unitId === item.key,
              );
              setUnit(selectedUnit);
            }}
            selected={unit.basicInfo.unitId}
          />
        </div>
      )}

      <div className="mb-3xl mt-lg">
        <AccountUnitDetailContainer accountUnitDetail={unit} />
      </div>
    </>
  );
}
